import React, { useState } from "react";
import "./imageLoader.css";

const ImageWithLoader = ({ src, alt, className }) => {
  const [loading, setLoading] = useState(true);

  return (
    <div className="img-wrapper">

      {/* Modern Loader */}
      <div className={`img-loader ${!loading ? "fade-out" : ""}`}>
        <div className="modern-spinner">

          {/* Rotating ring */}
          <div className="spinner-rotate"></div>

          {/* Pulse effect */}
          <div className="spinner-pulse"></div>

          {/* Center icon */}
      <div className="spinner-center">
  <svg viewBox="0 0 24 24" className="premium-home-icon">
      <defs>
    <linearGradient id="homeGradient" x1="0" y1="0" x2="24" y2="24">
      <stop offset="0%" stopColor="var(--color-primary)" />
      <stop offset="100%" stopColor="#06b6d4" />
    </linearGradient>
  </defs>

  <path d="M3 10L12 3l9 7" className="home-roof" />
  <rect x="6" y="10" width="12" height="10" rx="2" className="home-body" />
  <rect x="10" y="14" width="4" height="6" rx="1" className="home-door" />

    {/* Roof */}
    <path d="M3 10L12 3l9 7" className="home-roof" />
    
    {/* Body */}
    <rect x="6" y="10" width="12" height="10" rx="2" className="home-body" />
    
    {/* Door */}
    <rect x="10" y="14" width="4" height="6" rx="1" className="home-door" />
    
  </svg>
</div>

        </div>
      </div>

      <img
        src={src}
        alt={alt}
        className={`${className} img-main ${!loading ? "loaded" : ""}`}
        onLoad={() => setLoading(false)}
        onError={() => setLoading(false)}
      />
    </div>
  );
};

export default ImageWithLoader;